export default interface UsePartialPaymentUseCase {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postPartialPayment: (paymentData: any, formData: any) => Promise<undefined>;
}

/**
 * Provides an implementation for the dispute invoice service.
 *
 * This service requires user authentication and uses the Auth0 hook to
 * acquire an access token. It constructs a request payload for creating
 * a case in the system to dispute a customer's invoice. The payload includes
 * user details and invoice information. The service handles the API call
 * for posting an invoice dispute request.
 *
 * @returns {UsePartialPaymentUseCase} An object containing the function
 * `postDispute`, which posts the invoice dispute request to the API.
 */
export const usePartialPaymentService = (): UsePartialPaymentUseCase => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const postPartialPayment = async (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    paymentData: any,
    formData: {
      PAI_Account: string;
      PAI_Email: string;
      PAI_First_Name: string;
      PAI_Last_Name: string;
      PAI_Phone: string;
    }
  ): Promise<undefined> => {
    const OwnerId = `${process.env.NEXT_PUBLIC_BILLING_QUEUE_ID_SF_PAYLOAD}`;
    const RequesterC = `${process.env.NEXT_PUBLIC_REQUESTER__C_SF_PAYLOAD}`;

    const body = {
      Operation: "create",
      ObjectType: "case",
      ExternalID: [],
      sObjects: {
        sObject: {
          Portal_Customer_Number__c: formData.PAI_Account ? formData.PAI_Account : "",
          Portal_Email_Address__c: formData.PAI_Email ? formData.PAI_Email : "",
          Portal_First_Name__c: formData.PAI_First_Name ? formData.PAI_First_Name : "",
          Portal_Last_Name__c: formData.PAI_Last_Name ? formData.PAI_Last_Name : "",
          Portal_Phone_Number__c: formData.PAI_Phone ? formData.PAI_Phone.split(" ").slice(1).join("-") : "",
          ContactId: "",
          RecordTypeId: "0128c000001zT3fAAE",
          Status: "Submitted",
          Case_Issue_Subtype__c: "Invoice Short Pay-Guest Payment",
          Description: paymentData.enteredReason,
          OwnerId: OwnerId,
          Change_Action_Type__c: "Invoicing Help/Research",
          Internal_Comments__c: `Inv Description Test. Invoice or Contract# ${Number(
            paymentData.statement.SALES_DOCUMENT
          )}`,
          Requester__c: RequesterC,
          Case_Contact__c: "",
          Inovice_Number__c: Number(paymentData.DOC_NO),
          Order_Number__c: Number(paymentData.statement.SALES_DOCUMENT),
          Origin: "Web",
          AccountId: "",
          Case_Issue__c: "Billing Resolution",
          CurrencyIsoCode: paymentData.statement.CURRENCY,
          Subject: `Short Payment: ${paymentData.Reason}`,
        },
      },
    };

    const partialPayment = await fetch("/api/partial-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    return await partialPayment.json();
  };

  return { postPartialPayment };
};
